import React, { useState } from "react";

type Props = {
  title?: any;
  icon?: any;
  desc?: string;
  classname?: any;
  whiteIcon?: any;
  percent?: any;
  percentDesc?: any;
};

export default function SectionCardsMobile({
  title,
  icon,
  desc,
  classname,
  whiteIcon,
  percent,
  percentDesc,
}: Props) {
  const [enter, setEnter] = useState(false);
  const MouseEnter = () => {
    setEnter(true);
  };
  const MouseLeave = () => {
    setEnter(false);
  };
  return (
    <>
      <div
        className={`${classname} card-border-mobile landing-cards  text-center`}
        onMouseEnter={MouseEnter}
        onMouseLeave={MouseLeave}
      >
        <img
          className="pt-20 pb-10 w-40"
          src={enter ? whiteIcon : icon}
          alt={icon}
        />
        <p
          className={`font-18 pt-10 line-20 fonts-800 font-family-roboto-flex text-primary1 pb-10 text-center px-15`}
        >
          {title}
        </p>
        {desc && (
          <p className="text-white font-16 px-10 pt-10 font-family-roboto fonts-400 line-18">
            {enter ? desc : ""}
          </p>
        )}
        <p
          className={`text-teal-25 font-32 fonts-600 font-family-roboto-flex pb-10 text-center px-30 ${
            !enter && "border-gray-top"
          }`}
        >
          {enter ? "" : percent}
        </p>
        <p
          className={`text-black-95 font-family-roboto-flex pb-15 font-12 line-14 text-center px-5 `}
        >
          {enter ? "" : percentDesc}
        </p>
      </div>
    </>
  );
}
